<template>
    <div class="payment__card mt-5">
        <h3 class="payment__card-title" v-text="'Najbliższa płatność'" />

        <div v-if="payment" class="upcoming-payment border-bottom">
            <accordion
                header-class="upcoming-payment__header"
                :is-active="showDetails"
            >
                <template #header>
                    <div class="upcoming-payment__total row col-12 col-md-9 col-xl-6">
                        <!-- Total price -->
                        <div class="col-12 col-sm-6 d-flex flex-column align-items-center">
                            <p v-text="'Całkowity koszt brutto:'" class="mb-0" />
                            <div class="d-flex align-items-center">
                                <a-icon icon="Coins" class="text-orange mr-2" width="20" />
                                <p
                                    v-text="paymentTotalPrice"
                                    class="my-2 text-lg font-weight-bold"
                                />
                            </div>
                        </div>

                        <!-- Date -->
                        <div class="col-12 col-sm-6 d-flex flex-column align-items-center">
                            <p v-text="'Data płatności:'" class="mb-0" />
                            <div class="d-flex align-items-center">
                                <a-icon icon="Calendar" class="text-orange mr-2" width="17" />
                                <p
                                    v-text="paymentDate"
                                    class="my-2 text-lg font-weight-bold"
                                />
                            </div>
                        </div>
                    </div>
                </template>

                <template #expand-button>
                    <the-btn
                        text="Pokaż szczegóły"
                        class="btn-custom-gray btn-sm"
                        :icon="showDetails ? 'ArrowUp' : 'ArrowDown'"
                        :disabled="!filteredLocDetails.length"
                        @click="showDetails = !showDetails"
                    />
                </template>

                <template #body>
                    <!-- Location details -->
                    <div class="table-upcoming-payment c-table">
                        <div class="c-thead">
                            <div v-text="'Nazwa sklepu i adres sklepu'" class="c-td is-1" />
                            <div v-text="'Wybrany pakiet'" class="c-td" />
                            <div v-text="'Kwota netto'" class="c-td" />
                            <div v-text="'Limit urządzeń'" class="c-td is-4" />
                        </div>
                        <div class="c-tbody">
                            <div
                                v-for="loc in filteredLocDetails"
                                :key="loc.bo_location_id"
                                class="c-row"
                            >
                                <div class="c-tr">
                                    <div class="c-td is-1">
                                        <p
                                            v-text="loc.location_name || '---'"
                                            class="text-md font-weight-medium mb-1"
                                        />
                                        <p v-text="fullAddress(loc)" class="text-xs mb-0" />
                                    </div>
                                    <div class="c-td">
                                        <span v-text="'Wybrany pakiet'" class="typo-label" />
                                        {{ loc.current_subscription?.tariff_name }}
                                    </div>
                                    <div class="c-td">
                                        <span v-text="'Kwota netto'" class="typo-label" />
                                        {{ locTotalPrice(loc) }}
                                    </div>
                                    <div class="c-td is-4">
                                        <span v-text="'Limit urządzeń'" class="typo-label" />
                                        <div
                                            v-for="dev in locMappedDevices(loc)"
                                            :key="dev.id"
                                            class="d-flex justify-content-between mb-2"
                                        >
                                            <div class="d-flex align-items-center">
                                                <img
                                                    class="mr-2"
                                                    width="18"
                                                    :src="require(`@/assets/img/drs/${dev.img}`)"
                                                />

                                                <span v-text="dev.label" />
                                            </div>
                                            <span v-text="dev.count" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </accordion>
        </div>

        <div v-else v-text="'Brak wyników'" />
    </div>
</template>

<script>
import moment from 'moment'
import { DEVICE_TYPES } from '@/utils/constants/drs/store-devices.js'

export default {
    data: () => ({
        showDetails: false
    }),

    computed: {
        payment() {
            return this.$store.getters['payment/upcomingPayment']
        },
        paymentTotalPrice() {
            return this.$options.filters.currency(this.payment.total_price_gross / 100)
        },
        paymentDate() {
            return moment(this.payment.next_payment_date).format('DD-MM-YYYY')
        },
        filteredLocDetails() {
            return this.payment.payment_data.filter(el => el.current_subscription?.total_price)
        }
    },

    methods: {
        locTotalPrice(loc) {
            return this.$options.filters.currency(loc.current_subscription.total_discounted_price / 100)
        },
        locMappedDevices(loc) {
            const devices = loc.current_subscription?.device_type_subscriptions || []

            return DEVICE_TYPES.map(type => {
                const device = devices.find(d => d.device_type === type.device_type_subscriptions)
                return {
                    label: type.label,
                    img: type.img,
                    count: device?.count || 0
                }
            })
        },
        fullAddress(loc) {
            return this.$store.getters['drs/getLocations'].find(({ id }) =>
                id === loc.bo_location_id)?.fullAddress
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.upcoming-payment {
    .a-accordion, .a-accordion:hover {
        border: none;
        margin-bottom: 0 !important;
    }

    &__header {
        padding: 1rem 0;
    }

    &__total {
        font-size: 1rem;
        > div:first-child {
            border-right: 1px solid var(--color-gray-200);
        }
    }

    @include media-breakpoint-down(sm) {
        &__header {
            flex-wrap: wrap;

            button {
                margin-top: 1rem;
                width: 100%;
            }
        }

         &__total > div:first-child {
            border-right: 0;
            border-bottom: 1px solid var(--color-gray-200);
            padding-bottom: 1rem;
            margin-bottom: 1rem;
        }
    }
}

.table-upcoming-payment {
    .c-tr .typo-label {
        display: none;
    }

    .is-1 {
        flex: 0 0 45%;
        min-width: 45%;
    }
    .is-4 {
        flex: 0 0 12rem;
        min-width: 12rem;
        max-width: 12rem;
    }

    @include media-breakpoint-down(md) {
        .c-tr .typo-label {
            display: flex;
            margin-bottom: 0.25rem;
        }
        .c-thead {
            display: none;
        }
    }
}
</style>